module.exports = __webpack_public_path__ + "static/media/section2@2x.931e7805.png";